module.exports = __webpack_public_path__ + "img/PDF.4a6e11ff.png";